import styled from "styled-components";

export const Container = styled.div`
  position: relative;
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  padding: 0 10px;
  min-width: 104px;
  height: 44px;
  background-color: ${({ theme }) => theme.colorTokens.component.input.surface};
  box-shadow: 0 1px 3px rgba(17, 43, 68, 0.12);
  border-radius: 2px;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colorTokens.component.input.hover};
  }
`;

export const ButtonContent = styled.div`
  display: flex;
  flex-grow: 1;
  pointer-events: none;
`;
